import ReadMore from "./ReadMore";

export default function ServiceCard({children, img, title, href}) {

    return <a href={href}
              className="flex flex-col w-full sm:w-[280px] md:w-[320px] min-w-[320px] bg-white p-5 rounded-xl shadow-md text-center transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
        <img src={img} className="max-w-36 max-h-36 rounded-xl mx-auto"/>
        <h3 className="mb-2 mt-2 text-[#0a2540] text-xl font-semibold">
            {title}
        </h3>
        <p className="text-sm">
            {children}
        </p>
        <div className="mt-auto pt-4">
            <ReadMore />
        </div>
    </a>;
}